import { Box, Grid, Typography, useScrollTrigger } from "@mui/material";
import React, { useEffect, useState } from "react";
import { dashboardIcon, farmers, taskAssign } from "../../config/images";
import "../DataCollector/DataCollector.css";
import { useNavigate, useParams } from "react-router-dom";
import { deactivateDataCollectorList, getDataCollectorListDetails } from "../../config/services";
import translations from "../../config/language";
import { useSelector } from "react-redux";
import { notifyError, notifySuccess } from "../../config/ToastMessage";

const DataCollectorDetail = () => {
  const navigate = useNavigate();

  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [collectorDetails, setCollectorDetails] = useState({
    profileImage: null,
    FirstName: "",
    MiddleName: "",
    LastName: "",
    Gender: "",
    MobileNumber: "",
    Email: "",
    isActive: false,
  });

  const handleBackClick = () => {
    const currentPage = new URLSearchParams(window.location.search).get('page') || 1;
    navigate(`/collectors-list?page=${currentPage}`);
  };

  const { module_access } = useSelector((state) => state.userState)
  const isAccess = module_access?.find((module) =>
    module.module_name === "Data Collectors" && module.is_editor === true
  ) ? true : false;
  const fetchData = async () => {
    try {
      setLoading(true);
      const resp = await getDataCollectorListDetails(params.id);
      if (resp.data) {
        setCollectorDetails({
          profileImage: resp.data.profile_photo || "",
          FirstName: resp.data.first_name || "",
          MiddleName: resp.data.middle_name || "",
          LastName: resp.data.last_name || "",
          Gender: resp.data.gender == 0 ? "Male" : "Female",
          MobileNumber: resp.data.mobile_number || "",
          Email: resp.data.email || "",
          isActive: resp.data.is_active,
        })
        setLoading(false);
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log("error", error)
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  const handleDeactive = async () => {
    if (!isAccess) {
      notifyError(translations[language].youDontHaveAccess);
      return true;
    }
    try {
      const id = params.id;

      const data = {
        is_active: !collectorDetails.isActive,
        data_collector_id:id,
      }
      const resp = await deactivateDataCollectorList(id, data);
      if (resp.data.success == true) {
        fetchData();
        notifySuccess(resp.data.message);
      }
    } catch (error) {
      console.log("error", error)
    }
  }

  const language = process.env.REACT_APP_LANGUAGE;
  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => handleBackClick()}
            />
            <img
              src={taskAssign.collector}
              alt=""
              // style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].dataCollectors}
            </Typography>
          </Box>
          <Box className="d-flex align-items-center assign-data-btn">
            <button
              className="deactivate-btn"
              style={{ height: "46px", marginRight: "20px" }}
              onClick={handleDeactive}
            >
              {collectorDetails.isActive == true ? translations[language].deactivate: translations[language].activate}
            </button>
          </Box>
        </Box>
        <Box>
          <div className="user-profile">
            <Grid container spacing={2}>
              <Grid item lg={8}>
                <Grid container>
                  <Grid item lg={4} xs={12} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", paddingLeft: "20px" }}>
                    {translations[language].firstName}
                  </Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ borderTop: "1px solid #D9D9D9", fontWeight: 700 }}>
                    {collectorDetails.FirstName}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].middleName}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700 }}>
                    {collectorDetails?.MiddleName}

                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].lastName}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700 }}>
                    {collectorDetails?.LastName}
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].gender}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700 }}>
                    {collectorDetails?.Gender == "Male" ? translations[language].male : translations[language].female}

                  </Grid>
                </Grid>
                <Grid container >
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].mobileNumber}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700 }}>
                    {collectorDetails?.MobileNumber}
                  </Grid>
                </Grid>
                <Grid container >
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].email}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700 }}>
                    {collectorDetails?.Email}
                  </Grid>
                </Grid>
                <Grid container >
                  <Grid item lg={4} xs={12} className="grid-item" style={{ paddingLeft: "20px" }}>{translations[language].status}</Grid>
                  <Grid item lg={8} xs={12} className="grid-item" style={{ fontWeight: 700, color: collectorDetails.isActive == true ? "#31A05F" : "#3C4856" }}>
                    {collectorDetails.isActive == true ? "Active" : "In active"}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item lg={4}>
                {collectorDetails.profileImage ? (
                  <img
                    src={collectorDetails.profileImage}
                     alt=""
                    className="user-image"
                    style={{ height: "316px", width: "100%" }}
                  />) :
                  <img
                  src={dashboardIcon.profile}
                  alt=""
                  className="user-image"
                  style={{ height: "316px", width: "100%" }}
                />
                }

              </Grid>
            </Grid>
          </div>
        </Box>
      </Box>
    </>
  );
};

export default DataCollectorDetail;
